import {AboutUsView} from "./style";
import Banner1 from '../../assets/images/about-us/banner1.avif'
import Banner2 from '../../assets/images/about-us/banner2.avif'
import Banner3 from '../../assets/images/about-us/banner3.avif'
import Banner4 from '../../assets/images/about-us/banner4.avif'
import Banner5 from '../../assets/images/about-us/banner5.avif'
import Banner6 from '../../assets/images/about-us/banner6.avif'
import Banner7 from '../../assets/images/about-us/banner7.avif'
import Banner8 from '../../assets/images/about-us/banner8.avif'
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {AppState} from "store/app";
import {dynamicFormatSection, dynamicMatchTag, extractContent} from '../../utils/formatPage'
import parse from 'html-react-parser'
import {useEffect, useMemo, useState} from "react";

export default function AboutUS() {
  const {t} = useTranslation()
  const [content, setContent] = useState([])
  const {page} = useSelector(({AppReducer}: { AppReducer: AppState }) => AppReducer);


  useEffect(() => {
    if (!page) return
    const currentKey = Object.keys(page).find(item => item === 'aboutus')
    setContent(page[currentKey])
    console.log('page', page)
  }, [page])

  const content0 = useMemo(() => {
    if (!content.length) return {}
    const rawH1 = dynamicMatchTag(content[0], 'h1')
    const subSection = dynamicFormatSection(content[0], 'h2')
    return {
      title: extractContent(rawH1[0])[0],
      section1: subSection[0].split(rawH1[0])[1],
      section2: subSection[1],
    }
  }, [content])

  const content1 = useMemo(() => {
    if (!content.length) return {}
    const rawH1 = dynamicMatchTag(content[1], 'h1')
    return {
      title: extractContent(rawH1[0])[0],
      section1: content[1].split(rawH1[0])[1]
    }
  }, [content])

  const content2 = useMemo(() => {
    if (!content.length) return {}
    const rawH1 = dynamicMatchTag(content[2], 'h1')
    const subSection = dynamicFormatSection(content[2], 'h2')
    return {
      title: extractContent(rawH1[0])[0],
      section1: subSection[0].split(rawH1[0])[1],
      section2: subSection[1],
      section3: subSection[2].split('<h3>-</h3>'),
    }
  }, [content])

  const content3 = useMemo(() => {
    if (!content.length) return {}
    const rawH1 = dynamicMatchTag(content[3], 'h1')
    return {
      title: extractContent(rawH1[0])[0],
      section1: content[3].split(rawH1[0])[1]
    }
  }, [content])

  const content4 = useMemo(() => {
    if (!content.length) return {}
    const rawH1 = dynamicMatchTag(content[4], 'h1')
    return {
      title: extractContent(rawH1[0])[0],
      section1: content[4].split(rawH1[0])[1]
    }
  }, [content])

  return <AboutUsView>
    <h1 className="page-title" id="0">{content0?.title || ' '}</h1>
    <div className="view-layout-f-400">
      <div className="section-table-1">
        <>{content0.section1 && parse(content0?.section1)}</>
      </div>
      <div>
        <img src={Banner1} alt=""/>
      </div>
    </div>
    <div className="view-layout-400-f">
      <div>
        <img src={Banner2} alt=""/>
      </div>
      <div className="section-table-2">
        {content0.section2 && parse(content0?.section2)}
      </div>
    </div>
    <h1 className="page-title" id="1">{content1?.title || ' '}</h1>
    <div className="view-layout-f-400">
      <div>
        <img src={Banner3} alt=""/>
      </div>
      <div className="section">
        {content1.section1 && parse(content1?.section1)}
      </div>
    </div>
    <h1 className="page-title" id="2">{content2?.title || ' '}</h1>
    <div className="view-layout-f-400">
      <div className="section">
        {content2.section1 && parse(content2?.section1)}
      </div>
      <div>
        <img src={Banner4} alt=""/>
      </div>
    </div>
    <div className="view-layout-400-f">
      <div>
        <img src={Banner5} alt=""/>
      </div>
      <div className="section">
        {content2.section2 && parse(content2?.section2)}
      </div>
    </div>
    <div className="view-layout-f-f-400 ">
      <div className="section3-part">
        {content2?.section3?.length && parse(content2?.section3[0])}
      </div>
      <div className="section3-part part-last">
        {content2?.section3?.length && parse(content2?.section3[1])}
      </div>
      <div>
        <img src={Banner6} alt=""/>
      </div>
    </div>
    <h1 className="page-title" id="3">{content3?.title || ' '}</h1>
    <div className="view-layout-f-f view-layout-f-f-r">
      <div>
        <img src={Banner7} alt=""/>
      </div>
      <div className="section">
        {content3.section1 && parse(content3?.section1)}
      </div>
    </div>
    <h1 className="page-title" id="4">{content4?.title || ''}</h1>
    <div className="view-layout-f-f">
      <div className="section">
        {content4.section1 && parse(content4?.section1)}
      </div>
      <div>
        <img src={Banner8} alt=""/>
      </div>
    </div>
  </AboutUsView>
}
